import Alpine from 'alpinejs';
import '../alpine/include/global';
import { AlpineComponentTryba } from '../alpine/include/global';

interface NewDom {
    html: any,
    content: string;
    contentMenu: string;
    metas: {
        title: string;
        description: string;
        canonical: string;
    }
}

type SquareType = 'main' | 'secondary';

// const apiUrl = window.location.origin + '/api/product/content/';

// const getApiUrl = (url: string, productCurrentId: number, productSelectedId: number) => {
//     let productCurrentIdParameter = '?productCurrentId=' + productCurrentId
//     let productSelectedIdParameter = '&productSelectedId=' + productSelectedId
//     return url + productCurrentIdParameter + productSelectedIdParameter
// };

const updateDomContentWithNewProduct = (newProductUrl: string, productFrontUrl: string | null, scope: HTMLDivElement) => {
    fetch(newProductUrl)
        .then(async (response: Response) => {
            const newDom: NewDom = await response.json();
            // When there are multiple configurators, we need to update the content of each configurator within its own scope
            //Before : (document.querySelector('#ProductConfiguratorType') as HTMLDivElement).innerHTML = newDom.html;
            (scope as HTMLDivElement).innerHTML = newDom.html;
            const newURL = location.href.split('?')[0];
            window.history.pushState('object', document.title, newURL);

            if (productFrontUrl) {
                const link = document.querySelector('.configurator-discover-product-link');
                if (link) {
                    link.setAttribute('href', productFrontUrl);
                }
            }
        })
        .catch((e) => {
            console.log(e);
            console.log("La page n'a pas pu être cherchée. Affiher un message d'erreur a l'utilisateur");
        });
};

// window.addEventListener('popstate', (event) => {
//     if (event !== undefined && event.state) {
//         const { currentId, selectedId } = event.state;
//         const url = getApiUrl(apiUrl, currentId, selectedId);
//         updateDomContentWithNewProduct(url, null, document.querySelector('#ProductConfiguratorType') as HTMLDivElement);
//     }
// });

document.addEventListener('alpine:init', () => {
    Alpine.data('initConfigurator', (productCurrentId, productCurrentName, productCurrentVirtualSlug, flexVariant): AlpineComponentTryba => {
        const defaultFilter = window['configuratorDefaultMainFilter'] as any;
        const defaultTexture = window['configuratorDefaultSecondaryFilterData'] as any;
        return {
            flexVariant: flexVariant,
            choice: null,
            choice_type: null,
            choice_name: null,
            getMore: false,
            selectedColor: null,
            selectedTexture: null,
            productImage: document.getElementsByClassName('productImage'),
            nbOfitems: 0,
            nbOfItemsSquares: 0,
            nbOfItemsCircles: 0,
            selectedProductStyle: null,
            selectedProductStyleTexture: null,
            defaultBaseFilter: defaultFilter,
            defaultBaseTexture: defaultTexture,
            noFilters: false,
            productHeight: null,
            selected: false,
            activeChoiceId: null,
            currentScrollTop: 0,
            choiceIsOpen: false,
            containsTargetClass: false,
            smallImage: false,
            //A envoyer
            productCurrentId: productCurrentId,
            productCurrentName: productCurrentName,
            productCurrentVirtualSlug: productCurrentVirtualSlug,
            productSelectedId: null,
            productSelectedVirtualSlug: null,
            active: {
                couleur_texture: null,
                couleur_texture_name: null,
                subRange: null,
                baseFilter: null,
                baseFilterName: null,
                baseFilterImage: null,
            },
            //History + url
            hashFromUrl: [],
            hashArray: {},
            lastScroll: 0,
            init() {
                this.initStyledChoice(productCurrentName, 'subRange');
                if (this.$store.global.isMobile) {
                    this.nbOfItems = 6;
                    this.nbOfItemsSquares = 1;
                    this.nbOfItemsCircles = 1;
                } else {
                    this.nbOfItemsSquares = 3;
                    this.nbOfItemsCircles = 11;
                    this.nbOfItems = 11;
                    setTimeout(() => {
                        if (this.$refs.myProductPicture.offsetHeight) {
                            this.productHeight = 'height:' + this.$refs.myProductPicture.offsetHeight + 'px';
                        }
                    }, 300);
                }
                // if (this.flexVariant == false) {
                //Make base filter as active
                this.extractParameters();
                //}

                //Apply style if mobile
                if (this.$store.global.isMobile) {
                    this.choiceIsOpen = false;
                    const choices = document.querySelectorAll('.optionChoices');
                    choices.forEach((choice: any) => {
                        choice.style.display = 'none';
                    });
                }
            },
            handleFilters(item: any) {
                if (this.$refs.main) {
                    if (item == 1) {
                        this.$refs.main.classList.add('hidden');
                    }
                }

                // Adapt for multiple configurator
                if (this.$refs.contentToChange) {
                    if (item == 1) {
                        (this.$refs.contentToChange as HTMLDivElement).classList.add('hidden');
                    } else {
                        if ((this.$refs.contentToChange as HTMLDivElement).classList.contains('hidden')) {
                            (this.$refs.contentToChange as HTMLDivElement).classList.remove('hidden');
                        }
                    }
                }
            },
            checkScrolling() {
                this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                if (this.$store.global.isMobile) {
                    const currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value

                    if (currentScroll > 0 && this.lastScroll <= currentScroll) {
                        this.lastScroll = currentScroll;
                        if (this.$el.getBoundingClientRect().top == 0) {
                            // this.choiceIsOpen = true
                            this.smallImage = true;
                        }
                    }
                    if (currentScroll === 0) {
                        this.smallImage = false;
                    }
                }
            },
            extractParameters() {
                const queryString = window.location.search;

                if (queryString) {
                    const urlParams = new URLSearchParams(queryString);
                    const couleurTextureParam = urlParams.get('couleur_texture');
                    const baseFilterParam = urlParams.get('baseFilter');
                    const panneauFilterParam = urlParams.get('panneau');

                    if (baseFilterParam || panneauFilterParam) {
                        this.active['baseFilter'] = baseFilterParam ? baseFilterParam : panneauFilterParam;
                    }

                    if (couleurTextureParam) {
                        this.active['couleur_texture'] = couleurTextureParam;
                        window.localStorage.setItem('couleur_texture', this.active['couleur_texture']);
                        setTimeout(() => {
                            // let theclick = new Event("click")
                            // if (document.querySelector(`[data-choice_name="${this.active['baseFilter']}"]`)) {
                            //     document.querySelector(`[data-choice_name="${this.active['baseFilter']}"]`)!.dispatchEvent(theclick)
                            // }
                            if (this.$store.global.isMobile) {
                                const element = document.querySelector(`[data-choice_name_mobile="${this.active['couleur_texture']}"]`);

                                if (document.querySelector(`[data-choice_name="${this.active['baseFilter']}"]`)) {
                                    const baseFilterName = document.querySelector(`[data-choice_name="${this.active['baseFilter']}"]`);
                                    if (baseFilterName) {
                                        this.active['baseFilterName'] = baseFilterName.getAttribute('data-choice_mobile');
                                    }
                                }
                                this.activeStyle(element);
                            } else {
                                const domElement = document.querySelector(`[data-choice_name="${this.active['couleur_texture']}"]`);
                                let element: any = null;
                                if (domElement && domElement.children['0'] != undefined) {
                                    element = domElement.children['0'];
                                } else if (domElement) {
                                    element = domElement;
                                }
                                this.activeStyle(element);
                            }
                        }, 200);
                    } else {
                        if (this.defaultBaseFilter || this.defaultBaseTexture) {
                            setTimeout(() => {
                                this.active['baseFilter'] = this.defaultBaseFilter.slug;
                                if (this.defaultBaseTexture.children[0]) {
                                    this.active['couleur_texture'] = this.defaultBaseTexture.children[0].filter.slug;
                                    window.localStorage.setItem('couleur_texture', this.active['couleur_texture']);
                                } else {
                                    this.active['couleur_texture'] = this.defaultBaseTexture.filter.slug;
                                    window.localStorage.setItem('couleur_texture', this.active['couleur_texture']);
                                }
                                const element = document.querySelector(`[data-choice_name="${this.active['couleur_texture']}"]`);

                                // for panneau
                                const panneau = document.querySelector(`[data-choice_name="${this.active['baseFilter']}"]`);
                                if (panneau) {
                                    this.active['baseFilterName'] = panneau.getAttribute('data-choice_mobile');
                                    this.active['baseFilterImage'] = panneau.getAttribute('data-product_image');
                                }
                                this.activeStyle(element);
                            }, 200);
                        }
                    }
                } else {
                    if (this.defaultBaseFilter || this.defaultBaseTexture) {
                        setTimeout(() => {
                            // Recupérer la premiere texture du produit
                            const defaultColorHTML: HTMLElement = document.querySelector('[js-default-color-texture]') as HTMLElement;
                            const defaultColor: any = defaultColorHTML.dataset.texture;
                            this.active['baseFilter'] = this.defaultBaseFilter.slug;
                            if (this.defaultBaseTexture.children[0]) {
                                this.active['couleur_texture'] = this.defaultBaseTexture.children[0].filter.slug;
                                window.localStorage.setItem('couleur_texture', this.active['couleur_texture']);
                            } else {
                                // this.active['couleur_texture'] = this.defaultBaseTexture.filter.slug;
                                this.active['couleur_texture'] = defaultColor;
                                window.localStorage.setItem('couleur_texture', this.active['couleur_texture']);
                            }
                            const element = document.querySelector(`[data-choice_name="${this.active['couleur_texture']}"]`);
                            this.activeStyle(element);

                            // for panneau
                            const panneau = document.querySelector(`[data-choice_name="${this.active['baseFilter']}"]`);
                            if (panneau) {
                                this.active['baseFilterName'] = panneau.getAttribute('data-choice_mobile');
                                this.active['baseFilterImage'] = panneau.getAttribute('data-product_image');
                            }
                        }, 200);
                    } else {
                        this.noFilters = true;
                    }
                }
            },
            initUrl(type: string, data: string) {
                const url = new URL(window.location.href);
                const searchParams = new URLSearchParams(url.search);
                searchParams.append(type, data);
                url.search = searchParams.toString();
                window.history.replaceState(type, type, url.href);
            },
            // Styling choice
            initStyledChoice(choice: any, type: any) {
                this.active[type] = choice;
            },
            activeColor(choice: string, type: string, item: HTMLElement) {
                this.choiceIsOpen = false;
                this.active[type] = choice;
                if (this.flexVariant == false) {
                    this.addInUrl(type, choice);
                }
                this.replacePageTitleAndBreadcrumbTitle(item);
            },
            //Naviagtion between product matarials
            activeChoiceProduct(choice: string, type: string, id: string, virtualSlug: string, productUrl: string) {
                this.active[type] = choice;
                this.productSelectedId = id;
                if (this.flexVariant == false) {
                    this.productSelectedVirtualSlug = virtualSlug;
                }
                this.getNewProduct(productUrl);
            },
            replacePageTitleAndBreadcrumbTitle(item: string | HTMLDivElement) {
                const isPanneau = document.body.dataset.rangeSlug === 'portes-d-entree';
                if (!isPanneau) {
                    return;
                }
                let possibleFiltersNames: string[] = [''];
                let originalBaseFiltername = '';
                if (item instanceof HTMLElement) {
                    originalBaseFiltername = (item.textContent as string).trim();
                    const closest = item.closest('[x-ref="optionChoices"]');
                    // @ts-ignore
                    const firstRowWrapperDiv = closest === null ? item.parentElement?.parentElement : closest.parentElement?.previousElementSibling;
                    if (firstRowWrapperDiv) {
                        const otherFiltersNames = Array.from<Element>(firstRowWrapperDiv.querySelectorAll(':scope div')).map((value: Element): string => (value.textContent as string).replaceAll('\n', '').trim());
                        const otherFiltersNames2 = Array.from<Element>(this.$refs.optionChoices.querySelectorAll(':scope div')).map((value: Element): string => (value.textContent as string).replaceAll('\n', '').trim());
                        possibleFiltersNames = [...otherFiltersNames, ...otherFiltersNames2];
                    }
                }
                const pageTitle = document.querySelector('[data-js="product-title"]');
                const breadcrumb = document.querySelector('#easy_seo-breadcrumbs li:last-child span[itemprop="name"]');
                if (pageTitle && pageTitle.textContent && breadcrumb && breadcrumb.textContent) {
                    possibleFiltersNames.forEach((item) => {
                        const pageTitleContent = pageTitle.textContent as string;
                        const breadcrumbContent = breadcrumb.textContent as string;
                        pageTitle.textContent = pageTitleContent.replace(item, '');
                        breadcrumb.textContent = breadcrumbContent.replace(item, '');
                    });
                    pageTitle.textContent = (pageTitle.textContent as string).trim() + ' ' + originalBaseFiltername;
                    breadcrumb.textContent = (breadcrumb.textContent as string).trim() + ' ' + originalBaseFiltername;
                }
            },
            //The first choice
            activeChoice(choice: string, type: string, id: string, item: string | HTMLDivElement) {
                let choiceUrl: string | null = null;
                let squareType: SquareType | null = null;
                if (item instanceof HTMLElement) {
                    this.active['baseFilterName'] = item.getAttribute('data-choice_mobile');
                    this.active['baseFilterImage'] = item.getAttribute('data-product_image');
                    choiceUrl = item.getAttribute('data-secondary-filters-route');
                    squareType = item.getAttribute('data-squareType') as SquareType;
                }

                this.replacePageTitleAndBreadcrumbTitle(item);

                this.activeChoiceId = id;
                this.active[type] = choice;
                if (this.flexVariant == false) {
                    this.addInUrl(type, choice);
                }
                if (choiceUrl && squareType == 'main') {
                    fetch(window.location.origin + choiceUrl)
                        .then(async (response: Response) => {
                            this.choiceResult = await response.json();
                        })
                        .then(() => {
                            (this.$refs.contentToChange as HTMLDivElement).innerHTML = this.choiceResult.view;
                        })
                        .then(() => {
                            if (this.choiceResult.data.children.length == 1) {
                                (this.$refs.contentToChange as HTMLDivElement).classList.add('hidden');
                            } else {
                                if ((this.$refs.contentToChange as HTMLDivElement).classList.contains('hidden')) {
                                    (this.$refs.contentToChange as HTMLDivElement).classList.remove('hidden');
                                }
                            }

                            let domElement: any = null;
                            if (this.$refs.contentToChange) {
                                domElement = this.$refs.contentToChange.querySelectorAll('[data-choice_type="couleur_texture"]')[0];
                            }
                            let element: any = null;
                            if (this.flexVariant == false && domElement) {
                                this.addInUrl('couleur_texture', domElement.getAttribute('data-choice_name'));
                            }
                            //this.addInUrl('couleur_texture', domElement.getAttribute('data-choice_name'));
                            if (domElement) {
                                this.active['couleur_texture'] = domElement.getAttribute('data-choice_name');
                                if (domElement.hasAttribute('data-product_image')) {
                                    element = domElement;
                                } else if (domElement.children['0'].hasAttribute('data-product_image')) {
                                    element = domElement.children['0'];
                                } else if (domElement.children['0'].children['0'].hasAttribute('data-product_image')) {
                                    element = domElement.children['0'].children['0'];
                                } else {
                                    element = domElement.children['0'].children['0'].children['0'];
                                }
                            }
                            this.activeStyle(element ?? (item instanceof HTMLElement ? item : null));
                        })
                        .catch((e) => {
                            console.log('error', e);
                        });
                } else {
                    this.activeStyle(item);
                }
            },
            //Replace dom content about second choice
            getNewProduct(productFrontUrl) {
                // const response = await fetch(`/api/product/configurator/${this.productSelectedId}/`);
                // try {
                //     if (!response.ok) {
                //         throw new Error(response.statusText);
                //     }
                //     // const { isValid } = (await response.json()) as { isValid: boolean };
                //     console.log(response.json())
                //     return response;
                // } catch (e) {
                //     console.log(e);
                //     return e;
                // }
                // const url = getApiUrl(apiUrl, this.productCurrentId, this.productSelectedId);
                updateDomContentWithNewProduct(`/api/product/configurator/${this.productSelectedId}/?flexVariant=${this.flexVariant}`, productFrontUrl, this.$refs.simulatorProductContainer.parentElement?.parentElement as HTMLDivElement);
            },
            // Apply choice (textured product)
            activeStyle(styleChoice: HTMLDivElement | null) {
                const contentToChange = document.querySelector('#contentToChange') as HTMLDivElement | null;
                if (styleChoice) {
                    this.active['couleur_texture_name'] = styleChoice.getAttribute('data-choice_wording_mobile');
                    let productStyleTexture;
                    let productStyleTextureColor;
                    if ((styleChoice.children.length > 0 && styleChoice.children[0].getAttribute('data-product_image')) || (styleChoice.children.length > 0 && styleChoice.children[0].getAttribute('data-texture'))) {
                        productStyleTexture = styleChoice.children[0].getAttribute('data-product_image');
                        productStyleTextureColor = styleChoice.children[0].getAttribute('data-texture');
                    } else {
                        productStyleTexture = styleChoice.getAttribute('data-product_image');
                        productStyleTextureColor = styleChoice.getAttribute('data-texture');
                    }
                    this.choiceIsOpen = false;
                    this.selectedProductStyle = productStyleTexture;
                    this.selectedProductStyleTexture = productStyleTextureColor;
                    const firstImageOfSlider: HTMLImageElement | null = document.querySelector('[x-ref="swiperContainer"] img');
                    if (firstImageOfSlider) {
                        firstImageOfSlider.src = productStyleTexture;
                    }
                    const firstThumbnailOfSlider: HTMLImageElement | null = document.querySelector('.thumbsContainerClass img');
                    if (firstThumbnailOfSlider) {
                        firstThumbnailOfSlider.src = productStyleTexture;
                    }

                    if (contentToChange) {
                        contentToChange.classList.remove('hidden');
                    }
                } else {
                    const firstImageOfSlider: HTMLImageElement | null = document.querySelector('[x-ref="swiperContainer"] img');
                    if (firstImageOfSlider) {
                        this.selectedProductStyle = firstImageOfSlider.src;
                        if (contentToChange) {
                            contentToChange.classList.add('hidden');
                        }
                    }
                }
            },
            // Get more (Voir plus)
            showGetMore() {
                if (this.getMore == false) {
                    this.getMore = true;
                } else {
                    this.getMore = false;
                }
            },
            openChoices() {
                if (this.$store.global.isMobile) {
                    if (this.$refs.optionChoices.classList.contains('open')) {
                        this.$refs.optionChoices.classList.remove('open');
                        if (this.$refs.customSelect) {
                            this.$refs.customSelect.classList.remove('is-open');
                        }
                        this.$refs.optionChoices.style.display = 'none';
                    } else {
                        this.$refs.optionChoices.classList.add('open');
                        if (this.$refs.customSelect) {
                            this.$refs.customSelect.classList.add('is-open');
                        }
                        this.$refs.optionChoices.style.display = 'grid';
                        this.$refs.optionChoices.style.padding = '0 0 16px 0';
                    }

                    // this.resizePicture()
                }
            },
            resizePicture() {
                const selectElements: any = document.querySelectorAll('.customSelect');
                this.containsTargetClass = false;

                selectElements.forEach((element) => {
                    if (element.classList.contains('is-open')) {
                        this.containsTargetClass = true;
                        return;
                    }
                });

                if (this.containsTargetClass) {
                    this.choiceIsOpen = true;
                } else {
                    this.choiceIsOpen = false;
                }
            },
            closeChoices() {
                if (this.$store.global.isMobile && this.$refs.customSelect && this.$refs.optionChoices) {
                    this.$refs.customSelect.classList.remove('is-open');
                    this.$refs.optionChoices.classList.remove('open');
                    this.$refs.optionChoices.style.display = 'none';
                }
            },
            addInUrl(type: string, item: string) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const couleurTextureParam = urlParams.get('couleur_texture');
                const baseFilterParam = urlParams.get('baseFilter');
                const isPanneau = urlParams.get('panneau') !== null;

                const url = new URL(window.location.href);
                const searchParams = new URLSearchParams(url.search);

                if (type == 'couleur_texture') {
                    if (couleurTextureParam) {
                        urlParams.set('couleur_texture', item);
                        history.replaceState(null, 'couleur_texture', '?' + urlParams.toString());
                        window.localStorage.setItem('couleur_texture', item);
                    } else {
                        searchParams.append(type, item);
                        url.search = searchParams.toString();
                        window.history.replaceState(type, type, url.href);
                    }
                }
                if (type == 'baseFilter') {
                    if (baseFilterParam) {
                        urlParams.set('baseFilter', item);
                        if (isPanneau) {
                            urlParams.set('panneau', item);
                        }
                        history.replaceState(null, 'baseFilter', '?' + urlParams.toString());
                    } else {
                        searchParams.append(type, item);
                        url.search = searchParams.toString();
                        window.history.replaceState(type, type, url.href);
                    }
                }
            },
        };
    });
});
